.atm_c8_oadj2n.atm_c8_oadj2n{font-size:0.625rem;}
.atm_cs_1fw03zg.atm_cs_1fw03zg{font-weight:700;}
.atm_e2_f6fqlb{height:18px;}
.atm_j6_f6fqlb{min-height:18px;}
.atm_jb_f6fqlb{min-width:18px;}
.atm_vy_f6fqlb{width:18px;}
.atm_e2_1tcgj5g{height:24px;}
.atm_j6_1tcgj5g{min-height:24px;}
.atm_jb_1tcgj5g{min-width:24px;}
.atm_vy_1tcgj5g{width:24px;}
.atm_c8_1jaf4fe.atm_c8_1jaf4fe{font-size:0.75rem;}
.atm_e2_1vi7ecw{height:32px;}
.atm_j6_1vi7ecw{min-height:32px;}
.atm_jb_1vi7ecw{min-width:32px;}
.atm_vy_1vi7ecw{width:32px;}
.atm_c8_1j6vyhq.atm_c8_1j6vyhq{font-size:1rem;}
.atm_e2_1ylpe5n{height:40px;}
.atm_j6_1ylpe5n{min-height:40px;}
.atm_jb_1ylpe5n{min-width:40px;}
.atm_vy_1ylpe5n{width:40px;}
.atm_e2_fyhuej{height:48px;}
.atm_j6_fyhuej{min-height:48px;}
.atm_jb_fyhuej{min-width:48px;}
.atm_vy_fyhuej{width:48px;}
.atm_c8_1k8s52q.atm_c8_1k8s52q{font-size:1.5rem;}
.atm_e2_1fwpi09{height:64px;}
.atm_j6_1fwpi09{min-height:64px;}
.atm_jb_1fwpi09{min-width:64px;}
.atm_vy_1fwpi09{width:64px;}
.atm_e2_u29brm{height:80px;}
.atm_j6_u29brm{min-height:80px;}
.atm_jb_u29brm{min-width:80px;}
.atm_vy_u29brm{width:80px;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_2d_1byrjjm.atm_2d_1byrjjm{background-color:#E7EBEE;}
.atm_5j_1ssbidh{border-radius:50%;}
.atm_7l_1hutuam{color:#202328;}
.atm_9s_1txwivl{display:flex;}
.atm_e2_1osqo2v{height:100%;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_g3_kb7nvz.atm_g3_kb7nvz{line-height:1;}
.atm_ks_15vqwwr{overflow:hidden;}
.atm_mk_h2mmj6{position:relative;}
.atm_t9_angws6{text-transform:uppercase;}
.atm_gi_idpfg4{margin:0;}
.atm_w8mpmz_nb8q6m:focus{outline:2px solid #146EF5;}
.atm_119ht7c_1ssbidh:focus{border-radius:50%;}
.atm_1ukwr7f_tlke0l:hover{cursor:pointer;}
.atm_1vqdy9_1ssbidh #avatar-bottom-icon>:first-of-type{border-radius:50%;}
.atm_15pwfxf_stnw88 #avatar-bottom-icon>:first-of-type{position:absolute;}
.atm_sqkgm5_myb0kj #avatar-bottom-icon>:first-of-type{bottom:-4px;}
.atm_k0szfu_myb0kj #avatar-bottom-icon>:first-of-type{right:-4px;}
.atm_1d0lcgl_myb0kj #avatar-dot>:first-of-type{top:-4px;}
.atm_10yqpjd_myb0kj #avatar-dot>:first-of-type{right:-4px;}
.atm_k0szfu_grho7r #avatar-bottom-icon>:first-of-type{right:0px;}
.atm_1d0lcgl_1lpd5c9 #avatar-dot>:first-of-type{top:-5px;}
.atm_10yqpjd_12gsa0d #avatar-dot>:first-of-type{right:-2px;}
.atm_sqkgm5_1lpd5c9 #avatar-bottom-icon>:first-of-type{bottom:-5px;}
.atm_k0szfu_1lpd5c9 #avatar-bottom-icon>:first-of-type{right:-5px;}
.atm_sqkgm5_grho7r #avatar-bottom-icon>:first-of-type{bottom:0px;}
.atm_1d0lcgl_grho7r #avatar-dot>:first-of-type{top:0px;}
.atm_10yqpjd_1n1ank9 #avatar-dot>:first-of-type{right:-1px;}
.atm_sqkgm5_t94yts #avatar-bottom-icon>:first-of-type{bottom:1px;}
.atm_k0szfu_14y27yu #avatar-bottom-icon>:first-of-type{right:5px;}
.atm_1d0lcgl_t94yts #avatar-dot>:first-of-type{top:1px;}
.atm_10yqpjd_1l7b3ar #avatar-dot>:first-of-type{right:3px;}
.atm_hqelw_t94yts #avatar-dot>:first-of-type{bottom:1px;}
.atm_10yqpjd_14y27yu #avatar-dot>:first-of-type{right:5px;}
@keyframes gradient {
    0% {
      background-position: 0% 50%;
    }

    50% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }
.atm_5j_ftgil2{border-radius:8px;}
.atm_26_ny8due{background:linear-gradient(
    -90deg,
    #DCEBFE,
    #E0FAF8,
    #DCEBFE,
    #E0FAF8
  );}
.atm_2w_1tmuix4.atm_2w_1tmuix4{background-size:400% 400%;}
.atm_p_j3sr9e{animation:gradient 5s ease infinite;}
